import styled from '@emotion/styled';
import {
  COLOR_MUTED_TEXT,
  MOBILE_BREAKPOINT,
  COLOR_MUTED_BACKGROUND,
} from '../../components/PaywallsShared/constants';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  min-height: 400px;
  padding: 70px;
  text-align: center;
  background: ${COLOR_MUTED_BACKGROUND};
`;

export const Header = styled.h1`
  display: block;
  margin: 0 0 20px 0;
  font-weight: 800;
  font-size: 2.4rem;
`;

export const Content = styled.div`
  padding: 0 15%;
  color: ${COLOR_MUTED_TEXT};
  font-size: 1.6rem;
  line-height: 1.5;

  a {
    color: inherit;
    text-decoration: underline;
  }

  @media (max-width: ${MOBILE_BREAKPOINT}px) {
    padding: 0;
  }
`;
